import clsx from 'clsx';
import { PaletteUtils } from '@shared/utils';

interface DropDownIconProps {
  className?: string;
  isOpen?: boolean;
}

export const DropDownIcon = (props: DropDownIconProps) => {
  return (
    <div
      className={clsx(
        'h-[9px] w-[18px] relative transition-all duration-300',
        PaletteUtils.isBordierPalette ? '!text-[#dc291c]' : 'text-[#dadada] hover:text-[#e5c496]',
        props.isOpen ? 'rotate-180' : 'rotate-0',
        props.className,
      )}
    >
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15 9' fill='currentColor'>
        <path d='M13.25 0L7.5 5.595 1.75 0 0 1.703 7.5 9 15 1.703z' />
      </svg>
    </div>
  );
};
